<template>
    <div class="main-container">
    <div class="callme hidden-sm-and-down">
        <div class="container">
        <div class="callme-title">
            开启刘燕酿制之旅
            </div>
            <el-row :gutter="25">
            <el-col :span="8">
                <div class="grid-content bg-purple dw">
                <img class="hidden-xs-only" v-if="callmeimgpc.length && callmeimgpc[0].cover" :src="imgsrc+ callmeimgpc[0].cover" alt="">
                <div class="bgc">
                    <div class="callme-main">
                    <h4>致电我们</h4>
                    <p><a href="tel:callmedata.before_sale">全国服务热线：{{ callmedata.before_sale }}</a></p>
                    <!-- <p><a href="tel:callmedata.after_sale">售后服务：{{ callmedata.after_sale }}</a></p> -->
                    <!-- <p><a href="tel:callmedata.center">
                        <span>北京品牌中心：</span>
                        <span>{{ callmedata.center }}</span>
                    </a></p> -->
                    </div>
                </div>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="grid-content bg-purple">
                <img class="hidden-xs-only"  v-if="callmeimgpc.length && callmeimgpc[1].cover" :src=" imgsrc+ callmeimgpc[1].cover"   alt="">
                <div class="bgc">
                    <div class="callme-main">
                    <h4>E-MAIL我们</h4>
                    <p><a href="mailto:fngz@fngzgw.com">官方邮箱：{{ callmedata.email }}</a></p>
                    <p><a href="mailto:dlsyj@fngzgw.com">
                        <span>代理商反馈邮箱：</span>
                        <span>{{ callmedata.back_email }}</span>
                    </a></p>
                    </div>
                </div>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="grid-content bg-purple">
                <img class="hidden-xs-only" v-if="callmeimgpc.length && callmeimgpc[2].cover" :src="imgsrc + callmeimgpc[2].cover" alt="">
                <div class="bgc">
                    <div class="callme-main">
                    <h4>我们的地址</h4>
                    <p><a href="https://map.baidu.com/search/%E7%8F%A0%E6%B1%9F%E6%91%A9%E5%B0%94%E5%A4%A7%E5%8E%A6-6%E5%8F%B7%E6%A5%BC/@12946113.795,4853405.55,19z?querytype=s&da_src=shareurl&wd=%E7%8F%A0%E6%B1%9F%E6%91%A9%E5%B0%94%E5%A4%A7%E5%8E%A6-6%E5%8F%B7%E6%A5%BC&c=131&src=0&wd2=%E5%8C%97%E4%BA%AC%E5%B8%82%E6%98%8C%E5%B9%B3%E5%8C%BA&pn=0&sug=1&l=12&b=(12905478.56,4795107.47;13012998.56,4855587.47)&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&sug_forward=4c8cd9df3b7927e4f02d8332&device_ratio=1" target="_blank">{{ callmedata.address }}</a></p>
                    <p><a href="tel:4000017748">注:前来拜访请致电预约</a></p>
                    </div>
                </div>
                </div>
            </el-col>
            </el-row>
            <el-row>
            <el-col :span="24">
                <div class="grid-content bg-purple-dark time">
                刘燕酿制全国服务热线工作时间：{{ callmedata.work_time }}
                </div>
            </el-col>
            </el-row>
        </div>
    </div>

    <!-- 手机端显示 -->
    <div class="hidden-md-and-up callmemob">
         <img src="../../static/mobile/question.png" alt="">
         <p class="titletop">开启刘燕酿制之旅</p>
         <div class="phone">
            <div class="title">致电我们</div>
            <p><a href="tel:callmedata.before_sale">全国服务热线：{{ callmedata.before_sale }}</a></p>
            <!-- <p><a href="tel:callmedata.after_sale">售后服务：{{ callmedata.after_sale }}</a></p> -->
            <!-- <p><a href="tel:callmedata.center">
                <span>北京品牌中心：</span>
                <span>{{ callmedata.center }}</span>
            </a></p> -->
         </div>
         <div class="phone emall">
            <div class="title">E-MAIL我们</div>
            <p><a href="mailto:fngz@fngzgw.com">官方邮箱：{{ callmedata.email }}</a></p>
            <p><a href="mailto:dlsyj@fngzgw.com">
                <span>代理商反馈邮箱：</span>
                <span>{{ callmedata.back_email }}</span>
            </a></p>
         </div>
         <div class="phone emall">
           <h4 class="title">我们的地址</h4>
            <p style="width:4.48rem;margin:0 auto"><a href="https://map.baidu.com/search/%E7%8F%A0%E6%B1%9F%E6%91%A9%E5%B0%94%E5%A4%A7%E5%8E%A6-6%E5%8F%B7%E6%A5%BC/@12946113.795,4853405.55,19z?querytype=s&da_src=shareurl&wd=%E7%8F%A0%E6%B1%9F%E6%91%A9%E5%B0%94%E5%A4%A7%E5%8E%A6-6%E5%8F%B7%E6%A5%BC&c=131&src=0&wd2=%E5%8C%97%E4%BA%AC%E5%B8%82%E6%98%8C%E5%B9%B3%E5%8C%BA&pn=0&sug=1&l=12&b=(12905478.56,4795107.47;13012998.56,4855587.47)&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&sug_forward=4c8cd9df3b7927e4f02d8332&device_ratio=1" target="_blank">{{ callmedata.address }}</a></p>
            <p><a href="tel:4000017748">注:前来拜访请致电预约</a></p>
         </div>
         <p class="kefu">
           刘燕酿制全国服务热线工作时间：8:30-17:30
         </p>
    </div>
    </div>
</template>

<script>
import { callme_url ,callmeimg_url} from '../request/api'
export default {
    name: 'NewLiuyanShopWebCallme',
    components: {  },
    directives: {  },

    data() {
        return {
              callmedata: {},
            callmeimgpc: [],
        };
    },

    mounted() {
        callme_url().then((res)=>{
            this.callmedata = res.data.data
        })
        callmeimg_url({posters_cate_id:4}).then((res)=>{
         this.callmeimgpc = JSON.parse(JSON.stringify(res.data.data))
        })
    },

    methods: {
        
    },
};
</script>

<style lang="less" scoped>
.container {
    max-width: 1200px;
    padding: 5% 2% 0 2%;
    margin: 0 auto;
  
  }

  .callme-title {
    color: #00383F;
    line-height: 2em;
    border-bottom: 1px solid #00383F;
    text-align: left;
    margin-bottom: 40px;
    font-size: 22px;
  }

  .el-col {
    border-radius: 4px;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 36px;
    max-width: 1200px;
    position: relative;
  }

  .grid-content img {
    width: 100%;
  }

  .time {
    color: #00383F;
    line-height: 2em;
    background: url(../assets/cammle4.png) no-repeat center center/100% 100%;
    padding: 50px 0;
    margin: 40px 0;
    margin: 40px 0 20% 0;
    font-size: 20px;
    text-align: center;
  }

  .callme-main {
    position: absolute;
    width: 90%;
    left: 5%;
    top: 50%;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    font-weight: 500;
    text-align: center;
  }
  .callme-main a{
    font-size: 12px;
    color: #00383F;
  }
  .callme-main h4 {
    color: #00383F;
    font-weight: 500;
    line-height: 2.5em;
    font-size: 18px;
  }
  .bgc {
    position: absolute;
    width: 70%;
    left: 15%;
    height: 60%;
    top: 20%;
    line-height: 2em;
    color: #00383F;
  }

 @media (max-width: 991px) {
   .callmemob{
      color: #00383F;
     img{
       width: 100%;
     }
     .titletop{
        padding: 0.52rem 0;
        font-size: 0.48rem;
        font-weight: 900;
        border-bottom: 1px solid #00383F;
     }
     .emall{
       padding-top: 0.73rem!important;
     }
     .phone{
       padding-top: 0.52rem;
       .title{
         font-size: 0.3rem;
          font-weight: 900;
       }
       p{
         font-size: 0.2rem;
         font-weight: bold;
         padding: 0.1rem 0;
         margin: 0 auto;
         a{
           font-family:STKaitiSC-Bold;
           span{
             font-family:STKaitiSC-Bold;
           }
         }
       }
     }
   .kefu{
      font-size: 0.3rem;
      font-weight: bold;
      padding: 0.5rem 0 1.9rem 0;    
     }
   }
 }
</style>


// WEBPACK FOOTER //
// src/view/Callme.vue